import { render, staticRenderFns } from "./Applicant.vue?vue&type=template&id=890f3cba&scoped=true&"
import script from "./Applicant.vue?vue&type=script&lang=js&"
export * from "./Applicant.vue?vue&type=script&lang=js&"
import style0 from "./Applicant.vue?vue&type=style&index=0&id=890f3cba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890f3cba",
  null
  
)

export default component.exports